import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useFormik } from "formik";
import { Helmet } from "react-helmet-async";
import * as yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import Chip from "@mui/material/Chip";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Button from "@mui/material/Button";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Alert } from "@mui/material";
import { actionTypes, useStateValue } from "./../../store";
import FotterMain from "../BaseComponents/FotterMain";
import Header from "../BaseComponents/Header";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Slider from "react-slick";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import IconButton from "@mui/material/IconButton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from "html-react-parser";
import {
  baseURL,
  getDealerListByZipCode,
  getProductDetails,
  getProductStock,
} from "../../networkCalls";

import BtnCompare from "./BtnCompare";
import BtnWishList from "./BtnWishList";
import LoadingCellFullPage from "../LoadingCell/LoadingCellFullPage";
import BtnAddToCart from "./BtnAddToCart";
import { OverlayTrigger, Popover } from "react-bootstrap";
import ProductNotify from "./ProductNotify";
import ImageZoomCell from "./ImageZoomCell";
import NotifyEmailSetup from "./NotifyEmailSetup";
import SEO from "../BaseComponents/SEO";

const ProductDetail = () => {
  const location = useLocation();
  const { productID } = useParams();
  const [loading, setLoading] = useState(false);
  const [qtyCheck, setQtyCheck] = useState(false);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const [, dispatch] = useStateValue();

  const [value, setValue] = React.useState("1");
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const [delivery, setDelivery] = useState("viapin");
  // geo location
  // const [lat, setLat] = useState(null);
  // const [lng, setLng] = useState(null);
  // const [status, setStatus] = useState(null)
  // const getLocation = () => {
  // if (!navigator.geolocation) {
  //     setStatus('Geolocation is not supported by your browser');
  // } else {
  //     setStatus('Locating...');
  //     navigator.geolocation.getCurrentPosition((position) => {
  //         setStatus(null);
  //         setLat(position.coords.latitude);
  //         setLng(position.coords.longitude);
  //     }, () => {
  //         setStatus('Unable to retrieve your location');
  //     });
  // }
  // }
  const deliveryChange = (event) => {
    setDelivery(event.target.value);
  };
  const btnmyaccount = () => {
    dispatch({ type: actionTypes.SET_LOGINMODAL, value: true });
  };

  // Check pin code
  const validationSchemaPIN = yup.object({
    pin: yup
      .string("Enter your Pincode")
      .min(6, "Min 6 Digit")
      .max(6, "Max 6 Digit")
      .matches(/^[0-9]+$/, "Must be only digits")
      .required("You must specify a 6 Digit Pincode"),
  });
  const [checkPin, setCheckPin] = useState(false);
  const [dealerData, setDealerData] = useState("");
  const formikpin = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: validationSchemaPIN,
    onSubmit: (values) => {
      setCheckPin(true);
      setDealerData("");
      setSelectDealer("");
      setSelecWhs("");
      setAlertPincode(false);
      var data = new FormData();
      setProductStockAvail(null);
      data.append("zipCode", values.pin);
      data.append("mainCatId", productDetails?.mainCatId);
      getDealerListByZipCode(data).then((res) => {
        // console.log('getDealerListByZipCode', res.data)
        setCheckPin(false);
        switch (res.data.status) {
          case 1:
            setDealerData(res.data.dealerList);
            return true;
          case 0:
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "error" });
            dispatch({
              type: actionTypes.SET_MSGALERTDATA,
              value: res.data.msz,
            });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            break;
          default:
            return;
        }
      });
    },
  });
  // end check pin code

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });
  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    //autoplay: true,
    swipeToSlide: true,
    arrows: false,
    // dots: true,
    asNavFor: ".slider-nav",
    infinite: false,
    centerMode: false,
  };

  const settingsThumbs = {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: true,
    centerMode: false,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "10px",
    infinite: false,
  };

  const [noProductFound, setNoProductFound] = useState(false);
  const [productDetails, setProductDetails] = useState("");

  const pullProductData = () => {
    var data = new FormData();
    data.append("productSlug", productID);
    setLoading(true);
    getProductDetails(data).then((res) => {
      console.log("res getProductDetails", res);
      setLoading(false);
      setNoProductFound(false);
      switch (res.data.status) {
        case 1:
          setProductDetails(res.data?.productDetails);
          return true;
        case 0:
          setNoProductFound(true);
          break;
        default:
          return;
      }
    });
  };

  // select delear
  const [selectDealer, setSelectDealer] = React.useState("");
  const [selecWhs, setSelecWhs] = React.useState("");
  const [productStockAvail, setProductStockAvail] = React.useState(null);
  const [btnenabledbtn, setbtnenabledbtn] = React.useState(true);

  const selectDealerChange = (value) => {
    setSelectDealer(value);
  };
  const selectwhsChange = (value) => {
    setSelecWhs(value);
    setAlertPincode(false);
    var data = new FormData();
    data.append("inventoryItemId", productDetails?.inventoryItemId);
    data.append("whsId", value);
    // for (var pair of data.entries()) {
    //         console.log(pair[0] + ', ' + pair[1]);
    // }
    setQtyCheck(true);
    setbtnenabledbtn(true);
    getProductStock(data).then((res) => {
      // console.log('dsff', res.data)
      setQtyCheck(false);
      switch (res.data.status) {
        case 1:
          setProductStockAvail(res.data?.itemStock);
          setbtnenabledbtn(false);
          return true;
        case 0:
          setbtnenabledbtn(true);
          dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "error" });
          dispatch({
            type: actionTypes.SET_MSGALERTDATA,
            value: res?.data?.msz,
          });
          dispatch({ type: actionTypes.SET_MSGALERT, value: true });
          break;
        default:
          return;
      }
    });
  };
  const [alertPincode, setAlertPincode] = useState(false);

  const callback = useCallback((pass) => {
    setAlertPincode(pass);
    //pullAddressList();
  }, []);

  const popover = (
    <Popover id="popover-basic">
      {/* <Popover.Header as="h3">Price Details</Popover.Header> */}
      <Popover.Body>
        <div>
          <strong>Base Price: </strong>
          <CurrencyRupeeIcon className="fw-bold f12" />
          {productDetails?.productPrice}
        </div>
        <div>
          <strong>GST: </strong>
          <CurrencyRupeeIcon className="fw-bold f12" />
          {productDetails?.gstAmount} ({productDetails?.gstPercent})
        </div>
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    pullProductData();
  }, []);

  return (
    <>
      <SEO
        title={productDetails?.productMetaTitle}
        description={productDetails?.productMetaDescriptopn}
        name="HIPP - Honda India Power"
        url={`https://www.hondaindiapower.com${location?.pathname}`}
        type="Website"
      />
      <div
        id={`${productDetails?.mainCatId == 1 ? "marine-outboard-motor" : ""}`}
        className="product-details-body"
      >
        <Header />
        {loading ? (
          <>
            <LoadingCellFullPage />
          </>
        ) : (
          <>
            {noProductFound ? (
              <>
                <div>No Product Found</div>
              </>
            ) : (
              <>
                <div className="innerpagebg pt-5 pb-5">
                  <div className="container">
                    <div className="vh-100">
                      <div className="w-100">
                        <div
                          className="w-100 w-lg-72 w-md-100"
                          style={{ float: "left" }}
                        >
                          <div className="card mb-3">
                            <div className="row">
                              <div className="col-lg-5 col-md-12 col-12">
                                {/* <div className='product_imf_wrap_details'>
                                                            <img src="https://www.hondaindiapower.com/uploads/products/6/20XD_01.png" className='img-fluid' />
                                                        </div> */}
                                {/* <ImageZoomCell /> */}
                                <div className="slider-wrapper">
                                  <Slider
                                    {...settingsMain}
                                    asNavFor={nav2}
                                    ref={(slider) => setSlider1(slider)}
                                  >
                                    {productDetails &&
                                      productDetails?.productImages?.map(
                                        (slide, i) => (
                                          <ImageZoomCell
                                            key={i}
                                            slide={slide}
                                          />
                                        )
                                      )}
                                  </Slider>
                                  {productDetails &&
                                  productDetails?.productImages?.length > 1 ? (
                                    <>
                                      <div className="thumbnail-slider-wrap mb-3">
                                        <Slider
                                          {...settingsThumbs}
                                          asNavFor={nav1}
                                          ref={(slider) => setSlider2(slider)}
                                        >
                                          {productDetails?.productImages?.map(
                                            (slide, i) => (
                                              <div
                                                className="slick-slide"
                                                key={i}
                                              >
                                                <img
                                                  className="slick-slide-image border"
                                                  alt=""
                                                  src={`${slide.image}?img=${slide.id}`}
                                                />
                                                {/* <img className="slick-slide-image" src={`https://picsum.photos/800/400?img=${slide.id}`} /> */}
                                              </div>
                                            )
                                          )}
                                        </Slider>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col-lg-7 col-md-12 col-12 ps-4 pe-4">
                                <div className="pro_info mt-4">
                                  <h3 className="txtdgray mb-1 mt-4">
                                    {productDetails?.productName}
                                  </h3>
                                  <p className="txtred">
                                    {productDetails?.catLabel}
                                  </p>
                                  <p>{productDetails?.shortDescription}</p>
                                </div>
                                <div className="offer_info">
                                  <hr />
                                  {productDetails &&
                                    productDetails?.productOffers?.length > 0 &&
                                    productDetails?.productOffers?.map(
                                      (itemin, key) => (
                                        <div key={key}>
                                          <LocalOfferIcon className="f16 me-2 text-success" />
                                          {itemin?.name} - (Coupon Code:{" "}
                                          {itemin?.code})<hr />
                                        </div>
                                      )
                                    )}
                                </div>
                                <div className="d-flex mt-4 align-items-center">
                                  <div className="d-none">
                                    {productDetails?.productBrandLogo ? (
                                      <>
                                        <img
                                          src={productDetails?.productBrandLogo}
                                          className="border p-1 me-2"
                                          style={{ width: "100px" }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div>{productDetails?.productWarranty}</div>
                                </div>
                                <div className="me-3 mt-3 table-responsive mb-3">
                                  <div className="product-general-info">
                                    {productDetails &&
                                      productDetails?.productHighlight?.length >
                                        0 &&
                                      productDetails?.productHighlight?.map(
                                        (itemin, key) => (
                                          <div
                                            className="single-general-info d-flex"
                                            key={key}
                                          >
                                            <div style={{ width: "32px" }}>
                                              {/* <img src={`${baseURL}images/no-charges.png`} style={{ width: '24px' }} alt="" /> */}
                                              <StarBorderIcon
                                                color="error"
                                                className="me-2"
                                              />
                                            </div>
                                            <div className="">
                                              <span className="fw-bold">
                                                {itemin?.label}
                                              </span>{" "}
                                              {itemin?.value}
                                            </div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="w-100 w-lg-28 w-md-100"
                          style={{ float: "right" }}
                        >
                          <div className="card mb-3 ms-lg-2">
                            {productDetails?.forSale === "Y" &&
                            productDetails?.price > "0" ? (
                              <>
                                <div className="product__info-body p-3 pt-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="product__price product__price--current">
                                      <CurrencyRupeeIcon className="fw-bold f20" />
                                      {productDetails?.price}
                                      <OverlayTrigger
                                        trigger="click"
                                        placement="bottom"
                                        overlay={popover}
                                      >
                                        {/* <Button variant="success">Click me to see</Button> */}
                                        <IconButton
                                          aria-label="delete"
                                          size="small"
                                          className="ms-1"
                                          style={{ marginTop: "-15px" }}
                                        >
                                          <ContactSupportIcon fontSize="small" />
                                        </IconButton>
                                      </OverlayTrigger>
                                    </div>
                                    <div>
                                      {productStockAvail == null ? (
                                        <></>
                                      ) : (
                                        <>
                                          {productStockAvail &&
                                          productStockAvail > 0 ? (
                                            <>
                                              {" "}
                                              <Chip
                                                color="success"
                                                label="In Stock"
                                              />
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Chip
                                                color="error"
                                                label="Out Of Stock"
                                              />
                                            </>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}

                            {productDetails?.forSale === "N" ? (
                              <>
                                <div className="product__info-body p-3 pt-4 pb-1">
                                  <ProductNotify
                                    category={productDetails?.catLabel}
                                    model={productDetails?.productName}
                                  />
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {productDetails?.forSale === "Y" ? (
                              <>
                                <div className="product-form product__form p-3">
                                  {alertPincode ? (
                                    <>
                                      <Alert severity="error">
                                        Select Delivery Pincode!
                                      </Alert>
                                    </>
                                  ) : null}
                                  <FormControl className="w-100 mb-3">
                                    <FormLabel id="delivery-by" className="f14">
                                      Check Pincode
                                    </FormLabel>
                                    {/* <RadioGroup
                                                            row
                                                            aria-labelledby="delivery-by"
                                                            name="delivery-by-buttons-group"
                                                            value={delivery}
                                                            onChange={deliveryChange}
                                                        >
                                                            <FormControlLabel value="viapin" control={<Radio size="small" />} label="Pincode" />

                                                            <FormControlLabel value="vialoc" control={<Radio size="small" />} label="Location" />
                                                        </RadioGroup> */}
                                  </FormControl>
                                  {delivery == "viapin" ? (
                                    <div className="position-relative">
                                      <form
                                        onSubmit={formikpin.handleSubmit}
                                        autoComplete="off"
                                      >
                                        <div className="d-flex">
                                          <div className="flex-grow-1">
                                            <TextField
                                              className="mb-4 w-100"
                                              variant="standard"
                                              inputProps={{
                                                maxLength: 6,
                                              }}
                                              id="pin"
                                              name="pin"
                                              label=""
                                              placeholder="Enter Delivery Pincode"
                                              value={formikpin.values.pin}
                                              onChange={formikpin.handleChange}
                                              error={
                                                formikpin.touched.pin &&
                                                Boolean(formikpin.errors.pin)
                                              }
                                              helperText={
                                                formikpin.touched.pin &&
                                                formikpin.errors.pin
                                              }
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    <LocationOnIcon className="txtlgeay" />
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </div>
                                          <div>
                                            {checkPin ? (
                                              <>
                                                <LoadingButton
                                                  loading
                                                  variant="text"
                                                >
                                                  CHECK...
                                                </LoadingButton>
                                              </>
                                            ) : (
                                              <>
                                                <Button
                                                  variant="text"
                                                  type="submit"
                                                >
                                                  CHECK
                                                </Button>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        {/* <div className='w-100 d-none'>
                                                                {token ? <>
                                                                    <div className='p-2 f13 d-flex align-items-center justify-content-between'>
                                                                        Select Saved Addresses<Link className='linkblue btn btn-sm p-0 pe-1 f12' to="#" >Add New</Link>
                                                                    </div>
                                                                    <div className='p-2'>
                                                                        <div className='d-flex align-items-center pb-1'>
                                                                            <span className=''>201309</span> <LinesEllipsis
                                                                                text='office 307, Wizard Infoways Pvt Ltd, The Ithum Tower - A-40 Sector 62'
                                                                                maxLine='1'
                                                                                ellipsis='...'
                                                                                trimRight
                                                                                basedOn='letters'
                                                                                className='txtlgeay ms-1'
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </> : <>
                                                                    <div className='p-2 f13 d-flex align-items-center'>
                                                                        See your saved addresses <span className='linkblue btn btn-sm p-0 ps-1' onClick={btnmyaccount} >Login</span>
                                                                    </div>
                                                                </>}
                                                            </div> */}
                                      </form>
                                    </div>
                                  ) : (
                                    <>
                                      {/* <div className='d-flex mb-3'>
                                                            <div className='flex-grow-1 d-flex align-items-center' style={{ borderBottom: 'solid 1px #999' }}>
                                                                <GpsFixedIcon className='txtlgeay me-2' />
                                                                {lat}, {lng}
                                                            </div>
                                                            <div>
                                                                <Button variant="text" type="submit" onClick={() => getLocation()}>GET LOCATION</Button>
                                                            </div>
                                                        </div> */}
                                    </>
                                  )}

                                  <div className="delear-wrap">
                                    <FormControl sx={{ width: "100%" }}>
                                      {dealerData ? (
                                        <>
                                          <FormLabel
                                            id="dealer-label"
                                            className="mb-2 f12"
                                          >
                                            Select Dealer for Availabilty Check
                                          </FormLabel>
                                        </>
                                      ) : null}
                                      <div className="row">
                                        {dealerData &&
                                          dealerData?.length > 0 &&
                                          dealerData?.map((data, key) => (
                                            <div
                                              key={key}
                                              className="col-12"
                                              onClick={() => {
                                                selectDealerChange(
                                                  data?.dealerId
                                                );
                                                selectwhsChange(data?.whsId);
                                              }}
                                            >
                                              <div
                                                className={`border mb-2 bg-white rounded d-flex ${
                                                  selectDealer == data?.dealerId
                                                    ? "border-success"
                                                    : ""
                                                }`}
                                              >
                                                <Radio
                                                  checked={
                                                    selectDealer ==
                                                    data?.dealerId
                                                  }
                                                  value={data?.dealerId}
                                                  size="small"
                                                  name="radiodealer"
                                                  className="float-start"
                                                  inputProps={{
                                                    "aria-label": "A",
                                                  }}
                                                />
                                                <div className="flex-grow-1">
                                                  <div className="mt-2">
                                                    {data?.dealeName}
                                                  </div>
                                                  <div className="f10 pe-2">
                                                    {data?.address2}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                      </div>
                                    </FormControl>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            <div>
                              <div className="p-3 pt-1">
                                {productDetails?.forSale === "Y" &&
                                productDetails?.price > "0" ? (
                                  <>
                                    {qtyCheck ? (
                                      <>
                                        <LoadingButton
                                          className="w-100"
                                          loading
                                          variant="contained"
                                        >
                                          Check Availabilty...
                                        </LoadingButton>
                                      </>
                                    ) : (
                                      <>
                                        {productStockAvail === 0 ? (
                                          <>
                                            <NotifyEmailSetup
                                              model={
                                                productDetails?.productName
                                              }
                                              itemId={
                                                productDetails?.inventoryItemId
                                              }
                                              selectDealer={selectDealer}
                                              whsid={selecWhs}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <BtnAddToCart
                                              enabledbtn={btnenabledbtn}
                                              pid={productDetails?.productId}
                                              whsid={selecWhs}
                                              dealerid={selectDealer}
                                              inventoryItemId={
                                                productDetails?.inventoryItemId
                                              }
                                              pname={
                                                productDetails?.productName
                                              }
                                              pimg={
                                                productDetails
                                                  ?.productImages?.[0]?.image
                                              }
                                              pcat={productDetails?.catLabel}
                                              btnaddcallback={callback}
                                            />
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}
                                <div className="mt-3 d-flex align-items-center">
                                  {productDetails?.forSale === "Y" ? (
                                    <>
                                      <div className="w-50 pe-1">
                                        <BtnWishList
                                          pid={productDetails?.productId}
                                          btntype={"withlbl"}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <div
                                    className={`${
                                      productDetails?.forSale === "Y"
                                        ? "w-50 ps-1"
                                        : "w-100"
                                    }`}
                                  >
                                    <BtnCompare
                                      pid={productDetails?.productId}
                                      catid={productDetails?.mainCatId}
                                      btntype={"withlbl"}
                                      pname={productDetails?.productName}
                                      entryText={
                                        productDetails?.shortDescription
                                      }
                                      pimage={
                                        productDetails?.productImages?.[0]
                                          ?.image
                                      }
                                    />
                                  </div>
                                </div>
                                {productDetails?.productPDF != "" ? (
                                  <>
                                    <div className="mt-3">
                                      <a
                                        href={productDetails?.productPDF}
                                        variant="outline-secondary"
                                        className="btn btn-primary btn-sm w-100 shadow-sm"
                                        target="_blank"
                                      >
                                        Download Catalogue
                                      </a>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="w-100 w-lg-72"
                          style={{ float: "left" }}
                        >
                          {productDetails?.fullDescription ? (
                            <>
                              <div className="card mb-3">
                                <h3 className="p-3 mb-0 f16 fw-bold">
                                  DESCRIPTION
                                </h3>
                                <hr className="mb-1 mt-0" />
                                <div className="row">
                                  <div className="col-sm-12 f14">
                                    {/* <div className='p-3'>{productDetails?.fullDescription}</div> */}
                                    <div className="p-3">
                                      {parse(
                                        `${productDetails?.fullDescription}`
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {productDetails &&
                          productDetails?.productSpecification?.length > 0 ? (
                            <>
                              <div className="card mb-3">
                                <h3 className="p-3 mb-0 f16 fw-bold">
                                  SPECIFICATIONS
                                </h3>
                                <hr className="mb-1 mt-0" />
                                <div className="row">
                                  <div className="col-sm-12 f14">
                                    <div className="p-3">
                                      <div className="row">
                                        <div className="col-sm-12"></div>
                                        <div className="col-sm-12">
                                          {productDetails &&
                                            productDetails?.productSpecification
                                              ?.length > 0 &&
                                            productDetails?.productSpecification?.map(
                                              (itemin, key) => (
                                                <div key={key}>
                                                  <div className="d-flex align-items-center mb-2">
                                                    {itemin?.image != "" ? (
                                                      <>
                                                        <div className="me-2">
                                                          <img
                                                            src={itemin?.image}
                                                            alt={itemin?.label}
                                                            style={{
                                                              maxWidth: "38px",
                                                            }}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : null}
                                                    <div className="fw-bold f16">
                                                      {" "}
                                                      <span className="text-black">
                                                        {itemin?.label}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <table className="table table-sm table-striped table-hover f14">
                                                    <tbody>
                                                      {itemin?.list &&
                                                        itemin?.list?.length >
                                                          0 &&
                                                        itemin?.list?.map(
                                                          (listitem, key) => (
                                                            <tr key={key}>
                                                              <td>
                                                                {
                                                                  listitem?.label
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  listitem?.value
                                                                }
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                    </tbody>
                                                  </table>
                                                  <hr />
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {productDetails &&
                          productDetails?.productFeatures?.length > 0 ? (
                            <>
                              <div className="card mb-3">
                                <h3 className="p-3 mb-0 f16 fw-bold">
                                  FEATURES
                                </h3>
                                <hr className="mb-1 mt-0" />
                                <div className="row">
                                  <div className="col-sm-12 f14">
                                    <div className="p-3">
                                      <div className="row">
                                        <div className="col-sm-12"></div>
                                        <div className="col-sm-12">
                                          <table className="table table-sm table-striped table-hover f14">
                                            <tbody>
                                              {productDetails &&
                                                productDetails?.productFeatures
                                                  ?.length > 0 &&
                                                productDetails?.productFeatures?.map(
                                                  (itemin, key) => (
                                                    <tr key={key}>
                                                      <td>{itemin?.label}:</td>
                                                      <td>{itemin?.value}</td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {productDetails?.extraInfo ? (
                            <>
                              <div className="card mb-3">
                                <div className="row">
                                  <div className="col-sm-12 f14">
                                    {/* <div className='p-3'>{productDetails?.fullDescription}</div> */}
                                    <div className="p-3">
                                      {parse(`${productDetails?.extraInfo}`)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {productDetails &&
                          productDetails?.productFaqs?.length > 0 ? (
                            <>
                              <div className="card mb-3">
                                <h3 className="p-3 mb-0 f16 fw-bold">FAQ</h3>
                                <hr className="mb-1 mt-0" />
                                <div className="row">
                                  <div className="col-sm-12 f14">
                                    <div className="p-3">
                                      <div className="row">
                                        <div className="col-sm-12"></div>
                                        <div className="col-sm-12">
                                          {productDetails &&
                                            productDetails?.productFaqs
                                              ?.length > 0 &&
                                            productDetails?.productFaqs?.map(
                                              (itemin, key) => (
                                                <div key={key}>
                                                  <div className="d-flex">
                                                    <div className="fw500 f14">
                                                      {itemin?.question}
                                                    </div>
                                                  </div>
                                                  <div className="text-muted f14">
                                                    {itemin?.answer}
                                                  </div>
                                                  <hr
                                                    style={{
                                                      background: "#999",
                                                    }}
                                                  />
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}

                          <p className="f12">
                            <span className="text-danger">Disclaimer:</span> Due
                            to continuous improvement in product on the basis of
                            market feedback above specification are subject to
                            change with out any prior notice. Please contact
                            authorized dealer/distributor for latest
                            specification.
                          </p>
                        </div>
                        {productDetails?.ProductBanner !== "" && (
                          <div
                            className="w-100 w-lg-28 w-md-100"
                            style={{ float: "right" }}
                          >
                            <div className="card mb-3 ms-lg-2">
                              <img src={productDetails?.ProductBanner} />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div style={{ clear: "both", height: "40px" }}></div>
          </>
        )}
        <FotterMain />
      </div>
    </>
  );
};

export default ProductDetail;
